import { trpc } from "@/lib/trpc";

export const useModelsQuery = (
) => {
    return trpc.models.findMany.useQuery({})
};